export interface Credit {
  currentBalance: number
  history: CreditHistory[]
}

export interface CreditHistory {
  type: HistoryType
  amount: number
  author: string
  metadata: any
  date: Date
}

export enum HistoryType {
  add = 'add',
  deduct = 'deduct',
  orderPayment = 'orderPayment'
}

export const creditConverter: firebase.firestore.FirestoreDataConverter<Credit> = {
  toFirestore: giftBundle => {
    return {
      currentBalance: giftBundle.currentBalance,
      history: giftBundle.history
    }
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)

    let history: CreditHistory[] = []
    data.history.forEach((h: any) => {
      let hCopy = { ...h }
      hCopy.date = hCopy.date.toDate()
      history.push(hCopy)
    })

    return {
      currentBalance: data.currentBalance,
      history
    }
  }
}
